import { createTransform } from "redux-persist";

import { getAccessToken, getRefreshToken } from "../config/cookies";
import { Auth, AuthState } from "./ducks/auth/types";

export const authCredentialsTransform = createTransform<AuthState, AuthState>(
  (inboundState) => {
    if (!inboundState?.data) return inboundState;

    const { accessToken, chaveToken, ...data } = inboundState.data;

    return { ...inboundState, data: data as Auth };
  },
  (outboundState) => {
    if (!outboundState?.data) return outboundState;

    const accessToken = getAccessToken();
    const chaveToken = getRefreshToken();

    return {
      ...outboundState,
      data: {
        ...outboundState.data,
        ...(accessToken ? { accessToken } : {}),
        ...(chaveToken ? { chaveToken } : {}),
      },
    };
  },
  { whitelist: ["auth"] }
);
